import * as React from 'react';
import 'isomorphic-fetch';
import { ImageEditor } from "./ImageEditor";
export class ImageListEditor extends React.Component {
    constructor(props) {
        super(props);
        this.state = { loading: true, editingImageId: -1, images: null, currentNewImageName: "" };
        this.refresh();
    }
    render() {
        let result = React.createElement("div", null);
        if (this.state.loading) {
            result = React.createElement("div", null, "Fetching image list...");
        }
        else if (this.state.editingImageId != -1) {
            result = React.createElement("div", null,
                React.createElement(ImageEditor, { imageId: this.state.editingImageId }),
                React.createElement("br", null),
                React.createElement("button", { className: "btn btn-primary", onClick: () => this.onGoBackClicked() }, "Go back"));
        }
        else {
            let addNewImageSection = this.renderAddNewImageSection();
            let imageListSection = this.renderImageListSection();
            result = React.createElement("div", null,
                addNewImageSection,
                React.createElement("br", null),
                imageListSection);
        }
        return result;
    }
    renderAddNewImageSection() {
        return React.createElement("div", null,
            React.createElement("b", null, "Add new image to the list"),
            React.createElement("br", null),
            "Name: ",
            React.createElement("input", { className: "form-control", onChange: (e) => { this.onCurrentNewImageNameChanged(e.target.value); }, value: this.state.currentNewImageName }),
            React.createElement("button", { className: "btn btn-primary", onClick: () => this.onAddNewImageButtonClick() }, "Add"));
    }
    renderImageListSection() {
        let imageStyle = { "max-width": "200px", "height": "auto" };
        let imagesSection = React.createElement("table", { className: 'table' },
            React.createElement("thead", null,
                React.createElement("tr", null,
                    React.createElement("th", null, "Image Preview"),
                    React.createElement("th", null, "Id"),
                    React.createElement("th", null, "Image Id"),
                    React.createElement("th", null, "Data Guid"),
                    React.createElement("th", null, "Order"),
                    React.createElement("th", null, "Active"),
                    React.createElement("th", null, "Actions"))),
            React.createElement("tbody", null, this.state.images.map(imageListItem => {
                return React.createElement("tr", { key: imageListItem.id },
                    React.createElement("td", null,
                        React.createElement("img", { src: "Data/GetImage/" + imageListItem.imageId, style: imageStyle })),
                    React.createElement("td", null, imageListItem.id),
                    React.createElement("td", null, imageListItem.imageId),
                    React.createElement("td", null, imageListItem.dataGuid),
                    React.createElement("td", null, imageListItem.order),
                    React.createElement("td", null, imageListItem.active ? "enabled" : "disabled"),
                    React.createElement("td", null,
                        React.createElement("button", { className: "btn btn-primary", onClick: () => this.onUpdateVisualButtonClick(imageListItem.imageId) }, "Update Visual"),
                        " ",
                        React.createElement("button", { className: "btn btn-primary", onClick: () => this.onEnableDisableButtonClick(imageListItem.id) }, "Enable/Disable"),
                        " ",
                        React.createElement("button", { className: "btn btn-primary", onClick: () => this.onDeleteButtonClick(imageListItem.id) }, "Delete")));
            })));
        return React.createElement("div", null, imagesSection);
    }
    onAddNewImageButtonClick() {
        var addNewItemToImageListData = new AddNewItemToImageListData();
        addNewItemToImageListData.imageName = this.state.currentNewImageName;
        addNewItemToImageListData.imageListId = this.props.imageListId;
        fetch('Data/AddItemToImageList', {
            method: 'POST',
            credentials: 'same-origin',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json; charset=utf-8',
            },
            body: JSON.stringify(addNewItemToImageListData)
        })
            .then(response => response.json())
            .then(result => {
            this.refresh();
        });
    }
    refresh() {
        this.setState({ loading: true, editingImageId: -1, images: this.state.images, currentNewImageName: this.state.currentNewImageName });
        fetch('Data/GetImageListItems/' + this.props.imageListId, { credentials: 'same-origin' })
            .then(response => response.json())
            .then(data => {
            this.setState({ loading: false, images: data, currentNewImageName: this.state.currentNewImageName });
        });
    }
    onCurrentNewImageNameChanged(newImageName) {
        var newState = {
            loading: this.state.loading,
            editingImageId: this.state.editingImageId,
            images: this.state.images,
            currentNewImageName: newImageName
        };
        this.setState(newState);
    }
    onUpdateVisualButtonClick(imageId) {
        this.setState({ loading: false, editingImageId: imageId, images: this.state.images, currentNewImageName: this.state.currentNewImageName });
    }
    onEnableDisableButtonClick(imageListItemId) {
        this.refresh();
    }
    onDeleteButtonClick(imageListItemId) {
        var removeItemFromImageListData = new RemoveItemFromImageListData();
        removeItemFromImageListData.imageListItemId = imageListItemId;
        fetch('Data/RemoveItemToImageList', {
            method: 'POST',
            credentials: 'same-origin',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json; charset=utf-8',
            },
            body: JSON.stringify(removeItemFromImageListData)
        })
            .then(response => response.json())
            .then(result => {
            this.refresh();
        });
        this.refresh();
    }
    onGoBackClicked() {
        this.refresh();
    }
}
class AddNewItemToImageListData {
}
class RemoveItemFromImageListData {
}
//# sourceMappingURL=ImageListEditor.js.map


//////////////////
// WEBPACK FOOTER
// ./ClientApp/ImageListEditor.js
// module id = 35
// module chunks = 0